const uploadFileDialogStyle = () => ({
	fileUploadDialogBody: {
		textAlign: 'center',
		maxWidth: '352px',
		margin: '0 auto',
		padding: '48px 10px',
		'& > div': {
			marginBottom: '48px',
		},
	},
	errorVisible: {
		paddingTop: '16px',
	},
	fileUploadHeader: {
		marginBottom: '28px !important',
	},
	downloadLink: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
	},
});

export default uploadFileDialogStyle;
